import {
  BibliographyClass,
  BibliographySearchSortKey,
  BibliographySearchSortOrder,
  CollectionTarget,
  DisplayMethod,
  SearchTarget,
  SearchType
} from '@/types'
import {
  BibliographySearchNarrowCondition,
  BibliographySearchNarrowConditionToJSON
} from '@/api'

export interface BibliographyFreeSearchRequest {
  displayMethod: DisplayMethod
  searchTarget: SearchTarget
  numberOfLimit: number
  searchMethodAnd: boolean
  searchMethodSynonym: boolean
  searchMethodAllograph: boolean
  andSearchType: SearchType[]
  andCollectionTarget: CollectionTarget[]
  andMaterialFormat: string[]
  andBibliographyClass: BibliographyClass[]
  displayBranchCode?: string // この値は検索結果一覧の単独検索で行う
  freeWords: string
  bibliography: {
    classNo: string
  }
  collection: {
    collectionTypes: string[]
    shelfTypes: string[]
    callNumberMark: string
    callNumberNdc: string
    callNumberBook: string
    callNumberSub: string
    traderCodes: string[]
    donorCodes: string[]
    collectionStatus: string[]
    collectionStatusRemove: boolean
    holdingBranchCodes: string[]
    orderStatus: string[]
    orderBranchCodes: string[]
    acceptDateFrom: string
    acceptDateTo: string
    handlingTypes: string[]
    lendTotal: string
    lendTotalFlag: string
    lastLendDate: string
    lastLendDateFlag: string
  }
  narrow: BibliographySearchNarrowCondition
  sortKey: BibliographySearchSortKey
  sortOrder: BibliographySearchSortOrder
  page?: number
  _saveHistory: boolean
}

export function BibliographyFreeSearchRequestToJSON(
  value: BibliographyFreeSearchRequest
): any {
  return {
    display_method: value.displayMethod,
    search_target: value.searchTarget,
    number_of_limit:
      value.numberOfLimit !== 0 ? value.numberOfLimit : undefined,
    search_method_and: value.searchMethodAnd ?? undefined,
    search_method_synonym: value.searchMethodSynonym ?? undefined,
    search_method_allograph: value.searchMethodAllograph ?? undefined,
    and_search_type:
      value.searchMethodAnd && value.andSearchType.length !== 0
        ? value.andSearchType
        : undefined,
    and_collection_target:
      value.searchMethodAnd && value.andCollectionTarget.length !== 0
        ? value.andCollectionTarget
        : undefined,
    and_material_format:
      value.searchMethodAnd && value.andMaterialFormat.length !== 0
        ? value.andMaterialFormat
        : undefined,
    and_bibliography_class:
      value.searchMethodAnd && value.andBibliographyClass.length !== 0
        ? value.andBibliographyClass
        : undefined,
    display_branch_code:
      value.displayBranchCode !== '' ? value.displayBranchCode : undefined,
    free_words: value.freeWords !== '' ? value.freeWords : undefined,
    bibliography: {
      class_no:
        value.bibliography.classNo !== ''
          ? value.bibliography.classNo
          : undefined
    },
    collection: {
      collection_types:
        value.collection.collectionTypes.length !== 0
          ? value.collection.collectionTypes
          : undefined,
      shelf_types:
        value.collection.shelfTypes.length !== 0
          ? value.collection.shelfTypes
          : undefined,
      call_number_mark:
        value.collection.callNumberMark !== ''
          ? value.collection.callNumberMark
          : undefined,
      call_number_ndc:
        value.collection.callNumberNdc !== ''
          ? value.collection.callNumberNdc
          : undefined,
      call_number_book:
        value.collection.callNumberBook !== ''
          ? value.collection.callNumberBook
          : undefined,
      call_number_sub:
        value.collection.callNumberSub !== ''
          ? value.collection.callNumberSub
          : undefined,
      trader_codes:
        value.collection.traderCodes.length !== 0
          ? value.collection.traderCodes
          : undefined,
      donor_codes:
        value.collection.donorCodes.length !== 0
          ? value.collection.donorCodes
          : undefined,
      collection_status:
        value.collection.collectionStatus.length !== 0
          ? value.collection.collectionStatus
          : undefined,
      collection_status_remove: value.collection.collectionStatusRemove,
      holding_branch_codes:
        value.collection.holdingBranchCodes.length !== 0
          ? value.collection.holdingBranchCodes
          : undefined,
      order_status:
        value.collection.orderStatus.length !== 0
          ? value.collection.orderStatus
          : undefined,
      order_branch_codes:
        value.collection.orderBranchCodes.length !== 0
          ? value.collection.orderBranchCodes
          : undefined,
      accept_date_from:
        value.collection.acceptDateFrom !== ''
          ? value.collection.acceptDateFrom
          : undefined,
      accept_date_to:
        value.collection.acceptDateTo !== ''
          ? value.collection.acceptDateTo
          : undefined,
      handling_types:
        value.collection.handlingTypes.length !== 0
          ? value.collection.handlingTypes
          : undefined,
      lend_total:
        value.collection.lendTotal !== ''
          ? value.collection.lendTotal
          : undefined,
      lend_total_flag:
        value.collection.lendTotal !== '' &&
        value.collection.lendTotalFlag !== ''
          ? value.collection.lendTotalFlag
          : undefined,
      last_lend_date:
        value.collection.lastLendDate !== ''
          ? value.collection.lastLendDate
          : undefined,
      last_lend_date_flag:
        value.collection.lastLendDate !== '' &&
        value.collection.lastLendDateFlag !== ''
          ? value.collection.lastLendDateFlag
          : undefined
    },
    narrow: BibliographySearchNarrowConditionToJSON(value.narrow),
    sort_key: value.sortKey !== '' ? value.sortKey : undefined,
    sort_order: value.sortOrder !== '' ? value.sortOrder : undefined,
    page: value.page ?? undefined,
    _save_history: value._saveHistory ?? undefined
  }
}
